module.exports = __webpack_public_path__ + "img/chrome.fa4dff0a.png";